/**
*
* Menu
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { MenuList, MaterialIcon } from '@pearsontechnology/aero-components';
import { ThemeProvider, withTheme } from 'styled-components';

import themes from 'containers/App/themes';

import { Menu as MenuWrapper, MenuListItemText, StyledMenuListItem } from './styles';

const Menu = ({ items, theme }) => (
  <ThemeProvider theme={theme.themeId === 'dark' ? themes.dark : { ...themes.light, themeId: theme.themeId }}>
    <MenuWrapper>
      <MenuList>
        { items && items.map(({ action, label, icon }) => (
          <StyledMenuListItem
            key={label}
            disabled={!action}
            // TODO: Make this stopPropagation, when it works that you can edit
            // a screen that's not currently selected
            onClick={() => action && action()}
          >
            { icon && <MaterialIcon id={icon} /> }
            <MenuListItemText>{label}</MenuListItemText>
          </StyledMenuListItem>
        ))}
      </MenuList>
    </MenuWrapper>
  </ThemeProvider>
);

Menu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    action: PropTypes.func,
    icon: PropTypes.string,
  })).isRequired,
  theme: PropTypes.object,
};

export default withTheme(Menu);
